import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import ComplianceGraph from "components/Monitoring/ComplianceGraph";
import NextComplianceGraph from "components/Monitoring/NextComplianceGraph";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";

class ComplianceGraphContainer extends React.Component {
  render() {
    const { isNext } = this.props;
    return isNext ? <NextComplianceGraph {...this.props} /> : <ComplianceGraph {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

const mapStateToProps = (state, ownProps) => {
  const segmentId = isFinite(ownProps.segmentId) ? ownProps.segmentId : projectReducer.getSegmentId(state, ownProps.id);
  const runId = isFinite(ownProps.runId) ? ownProps.runId : projectReducer.getRunId(state, ownProps.id);
  return {
    compliancePlot: monitoringReducer.getCompliancePlot(state, ownProps.id, segmentId),
    setupLabels: setupReducer.getSetupLabels(state, runId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ComplianceGraphContainer);
